import {useAssetsImage} from '~/pages/context/AssetsImageContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut, faEllipsis, faClock } from "@fortawesome/free-solid-svg-icons";
import { faBell as faBellRegular } from "@fortawesome/free-regular-svg-icons";
import {Sun, Moon} from 'lucide-react';
import {Link, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useUserAvatar} from '~/pages/context/UserAvatarContext';
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
function HeaderAdmin(){
    const { userAvatar } = useUserAvatar();
    const [theme, setTheme] = useState("light");
    const {getImageUrlById} = useAssetsImage();
    const logo = getImageUrlById(39);
    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute("data-bs-theme", theme);
    })
    const navigate = useNavigate();
    const handleSignOut = (e) => {
        e.preventDefault();
        axios.post(`${apiUrl}/api/auth/admin-sign-out`, {}, {
            withCredentials: true
        })
            .then((res) => {
                if(res.data?.Succeeded){
                    navigate("/auth/admin-signin", { replace: true });
                }
            })
            .catch((err) => {
                ;
            })
    }
    return (
        <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
            <div className="collapse navbar-collapse justify-content-between">
                <div className="navbar-logo">
                    <button className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                            type="button" data-bs-toggle="collapse" data-bs-target="#navbarVerticalCollapse"
                            aria-controls="navbarVerticalCollapse" aria-expanded="false" aria-label="Toggle Navigation">
                        <span className="navbar-toggle-icon"><span className="toggle-line"></span></span>
                    </button>
                    <Link className="navbar-brand me-1 me-sm-3" to="/ai-chatbot">
                        {
                            logo &&
                            <img src={logo} alt="bt" width="50"/>
                        }
                    </Link>
                </div>
                <ul className="navbar-nav navbar-nav-icons flex-row">
                    <div className="nav-item">
                        <button type="button" className="px-2 border-0 p-0 btn" onClick={() => setTheme(theme == "light" ? "dark" : "light")}>
                            <div className="theme-control-toggle">
                                <div className="theme-control-toggle-label">
                                    {
                                        theme === "light" ? <Sun size={16}/> : <Moon size={16}/>
                                    }
                                </div>
                            </div>
                        </button>
                    </div>
                    <li className="nav-item dropdown">
                        <a className="nav-link" href="#" role="button" data-bs-toggle="dropdown " aria-haspopup="true"
                           aria-expanded="false" data-bs-auto-close="outside">
                            <FontAwesomeIcon icon={faBellRegular} className="text-body fs-7 mt-1"/>
                        </a>
                        <div
                            className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret"
                            id="navbarDropdownNotfication" aria-labelledby="navbarDropdownNotfication">
                            <div className="card position-relative border-0">
                                <div className="card-header p-2">
                                    <div className="d-flex justify-content-between">
                                        <h5 className="text-body-emphasis mb-0">Notifications</h5>
                                        <button className="btn btn-link p-0 fs-9 fw-normal" type="button">Mark all as
                                            read
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body p-0">
                                    <div className="scrollbar-overlay" data-simplebar="init" style={{height: '27rem'}}>
                                        <div className="simplebar-wrapper">
                                            <div className="simplebar-height-auto-observer-wrapper">
                                                <div className="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div className="simplebar-mask">
                                                <div className="simplebar-offset">
                                                    <div className="simplebar-content-wrapper" role="region"
                                                         aria-label="scrollable content">
                                                        <div className="simplebar-content">
                                                            <div
                                                                className="px-2 px-sm-3 py-3 notification-card position-relative read border-bottom">
                                                                <div
                                                                    className="d-flex align-items-center justify-content-between position-relative">
                                                                    <div className="d-flex">
                                                                        <div className="avatar avatar-m me-3">
                                                                            {
                                                                                logo &&
                                                                                <img className="rounded-circle" src={logo} alt=""/>
                                                                            }
                                                                        </div>
                                                                        <div className="flex-1 me-sm-3">
                                                                            <h4 className="fs-9 text-body-emphasis">Jessie
                                                                                Samson</h4>
                                                                            <p className="fs-9 text-body-highlight mb-2 mb-sm-3 fw-normal">
                                                                                <span className="me-1 fs-10">💬</span>Mentioned
                                                                                you in a comment.<span
                                                                                className="ms-2 text-body-quaternary text-opacity-75 fw-bold fs-10">10m</span>
                                                                            </p>
                                                                            <p className="text-body-secondary fs-9 mb-0">
                                                                                <FontAwesomeIcon icon={faClock}
                                                                                                 className="me-1"/>
                                                                                <span
                                                                                    className="fw-bold">10:41 AM </span>August
                                                                                7,2021
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="dropdown notification-dropdown">
                                                                        <button
                                                                            className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none"
                                                                            type="button" data-bs-toggle="dropdown"
                                                                            data-boundary="window" aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            data-bs-reference="parent">
                                                                            <FontAwesomeIcon icon={faEllipsis}
                                                                                             className="fs-10 text-body"/>
                                                                        </button>
                                                                        <div className="dropdown-menu py-2">
                                                                            <a className="dropdown-item" href="#!">
                                                                                Mark as unread
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="simplebar-placeholder"
                                                 style={{width: '0px', height: '0px'}}></div>
                                        </div>
                                        <div className="simplebar-track simplebar-horizontal"
                                             style={{visibility: 'hidden'}}>
                                            <div className="simplebar-scrollbar"
                                                 style={{width: '0px', display: 'none'}}>

                                            </div>
                                        </div>
                                        <div className="simplebar-track simplebar-vertical"
                                             style={{visibility: 'hidden'}}>
                                            <div className="simplebar-scrollbar" style={{
                                                height: '0px',
                                                display: 'none',
                                                transform: 'translate3d(0px, 113px, 0px)'
                                            }}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer p-0 border-top border-translucent border-0">
                                    <div className="my-2 text-center fw-bold fs-10 text-body-tertiary text-opactity-85">
                                        <Link className="fw-bolder" to="/home">Notification history</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link lh-1 pe-0" id="navbarDropdownUser" href="#!"
                           role="button" data-bs-toggle="dropdown"
                           data-bs-auto-close="outside" aria-haspopup="true"
                           aria-expanded="false">
                            <div className="avatar avatar-l ">
                                <img className="rounded-circle " src={userAvatar.AvatarUrl} alt=""/>
                            </div>
                        </a>
                        <div
                            className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                            aria-labelledby="navbarDropdownUser">
                            <div className="card position-relative border-0">
                                <div className="card-body p-0">
                                    <div className="text-center pt-4 pb-3">
                                        <div className="avatar avatar-xl ">
                                            <img className="rounded-circle " src={userAvatar.AvatarUrl} alt=""/>
                                        </div>
                                        <h6 className="mt-2 text-body-emphasis">{userAvatar.UserName}</h6>
                                        <h6 className="mt-2 text-body-emphasis">{userAvatar.Email}</h6>
                                    </div>
                                </div>
                                <div className="card-footer p-0 border-0">
                                    <div className="px-3">
                                        <a className="btn btn-bt-secondary d-flex flex-center w-100" href="#" onClick={handleSignOut}>
                                            <FontAwesomeIcon icon={faSignOut} className="me-2 text-body align-bottom"/>
                                            Sign out
                                        </a>
                                    </div>
                                    <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                                        <Link className="text-body-quaternary me-1" to="/home">Privacy policy</Link>
                                        •<Link className="text-body-quaternary mx-1" to='/home'>Terms</Link>
                                        •<Link className="text-body-quaternary ms-1" to='/home'>Cookies</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default HeaderAdmin;